import { Component, ElementRef, Input, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { FeatureService, TalentAppFeatures } from "../../service/feature.service";
import { PreInterviewQuestion } from "../../../typings";

@Component({
    selector: 'app-pre-interview-questions-view',
    templateUrl: './pre-interview-questions-view.component.html',
    styleUrls: ['./pre-interview-questions-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreInterviewQuestionsViewComponent {

  @ViewChildren('questionComponentCheckbox') questionComponentCheckboxes!: QueryList<ElementRef>
  @Input() staticQuestionsList: PreInterviewQuestion[];
  @Input() customQuestionsList: PreInterviewQuestion[];
  @Input() aiQuestionsList: PreInterviewQuestion[];
  @Input() activeQuestionCount: number = -1;
  aiGeneratedFeature = this.featureService.getFeature(TalentAppFeatures.AI_GENERATED_PRE_INTERVIEW_QUESTIONS);

  pageState: string = 'view';

  constructor(private featureService: FeatureService) {}
}
